// src/enums.ts
var RiskLevel = {
  LOW: "LOW",
  MODERATE: "MODERATE",
  HIGH: "HIGH",
  CRITICAL: "CRITICAL"
};
var RecordStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  ARCHIVED: "ARCHIVED",
  DELETED: "DELETED"
};
var ProjectStatus = {
  PLANNING: "PLANNING",
  ACTIVE: "ACTIVE",
  ON_HOLD: "ON_HOLD",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED"
};
var ProjectPhase = {
  PURSUIT: "PURSUIT",
  ESTIMATING: "ESTIMATING",
  PRECONSTRUCTION: "PRECONSTRUCTION",
  DESIGN_COORDINATION: "DESIGN_COORDINATION",
  PROCUREMENT: "PROCUREMENT",
  MOBILIZATION: "MOBILIZATION",
  ACTIVE_CONSTRUCTION: "ACTIVE_CONSTRUCTION",
  PUNCH_LIST: "PUNCH_LIST",
  CLOSEOUT: "CLOSEOUT",
  WARRANTY: "WARRANTY"
};
var RecommendationStatus = {
  DRAFT: "DRAFT",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  ASSIGNED: "ASSIGNED",
  DISMISSED: "DISMISSED",
  EXECUTED: "EXECUTED"
};
var AgentStatus = {
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
  DEGRADED: "DEGRADED",
  ERROR: "ERROR"
};
var AlertStatus = {
  OPEN: "OPEN",
  ACKNOWLEDGED: "ACKNOWLEDGED",
  RESOLVED: "RESOLVED",
  DISMISSED: "DISMISSED"
};
var NotificationType = {
  INFO: "INFO",
  SUCCESS: "SUCCESS",
  WARNING: "WARNING",
  CRITICAL: "CRITICAL",
  SYSTEM: "SYSTEM"
};
var NotificationChannel = {
  IN_APP: "IN_APP",
  EMAIL: "EMAIL",
  SMS: "SMS",
  WEBHOOK: "WEBHOOK"
};
var IntegrationStatus = {
  PENDING: "PENDING",
  CONNECTED: "CONNECTED",
  DISCONNECTED: "DISCONNECTED",
  ERROR: "ERROR"
};
var ApiKeyStatus = {
  ACTIVE: "ACTIVE",
  REVOKED: "REVOKED"
};
var WebhookStatus = {
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
  FAILED: "FAILED"
};

// src/client-launch-catalog.ts
var CLC_SPEND_CATALOG = [
  {
    key: "OCCUPANCY_UTILITIES",
    order: 1,
    label: "Occupancy & Utilities",
    items: [
      {
        key: "OCCUPANCY_UTILITIES__OFFICE_RENT_OR_MORTGAGE",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 1,
        title: "Office rent or mortgage",
        completenessRule: null
      },
      {
        key: "OCCUPANCY_UTILITIES__YARD_SHOP_STORAGE_RENT",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 2,
        title: "Yard / shop / storage rent",
        completenessRule: null
      },
      {
        key: "OCCUPANCY_UTILITIES__ELECTRIC",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 3,
        title: "Electric",
        completenessRule: null
      },
      {
        key: "OCCUPANCY_UTILITIES__NATURAL_GAS_HEATING_OIL_PROPANE",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 4,
        title: "Natural gas / heating oil / propane",
        completenessRule: null
      },
      {
        key: "OCCUPANCY_UTILITIES__WATER_SEWER",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 5,
        title: "Water & sewer",
        completenessRule: null
      },
      {
        key: "OCCUPANCY_UTILITIES__TRASH_RECYCLING",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 6,
        title: "Trash & recycling",
        completenessRule: null
      },
      {
        key: "OCCUPANCY_UTILITIES__LANDSCAPING_SNOW_REMOVAL",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 7,
        title: "Landscaping / snow removal",
        completenessRule: null
      },
      {
        key: "OCCUPANCY_UTILITIES__JANITORIAL_CLEANING",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 8,
        title: "Janitorial / cleaning",
        completenessRule: null
      },
      {
        key: "OCCUPANCY_UTILITIES__SECURITY_SYSTEM_ALARM_MONITORING",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 9,
        title: "Security system & alarm monitoring",
        completenessRule: null
      },
      {
        key: "OCCUPANCY_UTILITIES__BUILDING_MAINTENANCE_REPAIRS",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 10,
        title: "Building maintenance & repairs",
        completenessRule: null
      },
      {
        key: "OCCUPANCY_UTILITIES__PROPERTY_TAXES_IF_OWNED",
        categoryKey: "OCCUPANCY_UTILITIES",
        categoryLabel: "Occupancy & Utilities",
        categoryOrder: 1,
        lineOrder: 11,
        title: "Property taxes (if owned)",
        completenessRule: null
      }
    ]
  },
  {
    key: "TELECOM_CONNECTIVITY",
    order: 2,
    label: "Telecom & Connectivity",
    items: [
      {
        key: "TELECOM_CONNECTIVITY__OFFICE_INTERNET_PRIMARY_ISP",
        categoryKey: "TELECOM_CONNECTIVITY",
        categoryLabel: "Telecom & Connectivity",
        categoryOrder: 2,
        lineOrder: 1,
        title: "Office internet / primary ISP",
        completenessRule: null
      },
      {
        key: "TELECOM_CONNECTIVITY__BACKUP_INTERNET_CIRCUIT",
        categoryKey: "TELECOM_CONNECTIVITY",
        categoryLabel: "Telecom & Connectivity",
        categoryOrder: 2,
        lineOrder: 2,
        title: "Backup internet circuit",
        completenessRule: null
      },
      {
        key: "TELECOM_CONNECTIVITY__OFFICE_PHONE_SYSTEM_VOIP",
        categoryKey: "TELECOM_CONNECTIVITY",
        categoryLabel: "Telecom & Connectivity",
        categoryOrder: 2,
        lineOrder: 3,
        title: "Office phone system / VoIP",
        completenessRule: null
      },
      {
        key: "TELECOM_CONNECTIVITY__MOBILE_PHONE_PLAN_ALL_LINES",
        categoryKey: "TELECOM_CONNECTIVITY",
        categoryLabel: "Telecom & Connectivity",
        categoryOrder: 2,
        lineOrder: 4,
        title: "Mobile phone plan (all lines)",
        completenessRule: null
      },
      {
        key: "TELECOM_CONNECTIVITY__JOBSITE_INTERNET_HOTSPOTS",
        categoryKey: "TELECOM_CONNECTIVITY",
        categoryLabel: "Telecom & Connectivity",
        categoryOrder: 2,
        lineOrder: 5,
        title: "Jobsite internet / hotspots",
        completenessRule: null
      },
      {
        key: "TELECOM_CONNECTIVITY__E_FAX_SERVICE",
        categoryKey: "TELECOM_CONNECTIVITY",
        categoryLabel: "Telecom & Connectivity",
        categoryOrder: 2,
        lineOrder: 6,
        title: "E-fax service",
        completenessRule: null
      },
      {
        key: "TELECOM_CONNECTIVITY__CONFERENCING_ZOOM_TEAMS_ADD_ONS",
        categoryKey: "TELECOM_CONNECTIVITY",
        categoryLabel: "Telecom & Connectivity",
        categoryOrder: 2,
        lineOrder: 7,
        title: "Conferencing (Zoom, Teams add-ons)",
        completenessRule: null
      },
      {
        key: "TELECOM_CONNECTIVITY__ANSWERING_SERVICE",
        categoryKey: "TELECOM_CONNECTIVITY",
        categoryLabel: "Telecom & Connectivity",
        categoryOrder: 2,
        lineOrder: 8,
        title: "Answering service",
        completenessRule: null
      }
    ]
  },
  {
    key: "IT_INFRASTRUCTURE",
    order: 3,
    label: "IT & Infrastructure",
    items: [
      {
        key: "IT_INFRASTRUCTURE__IT_PROVIDER_MSP_MONTHLY_RETAINER",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 1,
        title: "IT provider / MSP monthly retainer",
        completenessRule: "MSP_RETAINER_AND_PROJECTS"
      },
      {
        key: "IT_INFRASTRUCTURE__IT_PROJECT_WORK_LAST_12_MONTHS_TOTAL",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 2,
        title: "IT project work (last 12 months total)",
        completenessRule: "MSP_RETAINER_AND_PROJECTS"
      },
      {
        key: "IT_INFRASTRUCTURE__HELP_DESK_AFTER_HOURS_SUPPORT",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 3,
        title: "Help desk / after-hours support",
        completenessRule: null
      },
      {
        key: "IT_INFRASTRUCTURE__SERVER_NAS_OR_ON_PREM_HARDWARE",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 4,
        title: "Server, NAS or on-prem hardware",
        completenessRule: null
      },
      {
        key: "IT_INFRASTRUCTURE__CLOUD_BACKUP_DISASTER_RECOVERY",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 5,
        title: "Cloud backup & disaster recovery",
        completenessRule: null
      },
      {
        key: "IT_INFRASTRUCTURE__ANTIVIRUS_ENDPOINT_PROTECTION",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 6,
        title: "Antivirus / endpoint protection",
        completenessRule: null
      },
      {
        key: "IT_INFRASTRUCTURE__EMAIL_SECURITY_SPAM_FILTERING",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 7,
        title: "Email security / spam filtering",
        completenessRule: null
      },
      {
        key: "IT_INFRASTRUCTURE__PASSWORD_MANAGER",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 8,
        title: "Password manager",
        completenessRule: null
      },
      {
        key: "IT_INFRASTRUCTURE__VPN_REMOTE_ACCESS",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 9,
        title: "VPN / remote access",
        completenessRule: null
      },
      {
        key: "IT_INFRASTRUCTURE__DEVICE_LEASING_OR_FINANCING",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 10,
        title: "Device leasing or financing",
        completenessRule: null
      },
      {
        key: "IT_INFRASTRUCTURE__HARDWARE_REFRESH_LAST_12_MONTHS_TOTAL",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 11,
        title: "Hardware refresh (last 12 months total)",
        completenessRule: null
      },
      {
        key: "IT_INFRASTRUCTURE__PRINTER_COPIER_MFP_LEASE_SERVICE",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 12,
        title: "Printer / copier / MFP lease & service",
        completenessRule: null
      },
      {
        key: "IT_INFRASTRUCTURE__PLOTTER_LARGE_FORMAT_PRINTER_SUPPLIES",
        categoryKey: "IT_INFRASTRUCTURE",
        categoryLabel: "IT & Infrastructure",
        categoryOrder: 3,
        lineOrder: 13,
        title: "Plotter / large-format printer & supplies",
        completenessRule: null
      }
    ]
  },
  {
    key: "CLOUD_PRODUCTIVITY",
    order: 4,
    label: "Cloud & Productivity Software",
    items: [
      {
        key: "CLOUD_PRODUCTIVITY__MICROSOFT_365_OR_GOOGLE_WORKSPACE",
        categoryKey: "CLOUD_PRODUCTIVITY",
        categoryLabel: "Cloud & Productivity Software",
        categoryOrder: 4,
        lineOrder: 1,
        title: "Microsoft 365 or Google Workspace",
        completenessRule: null
      },
      {
        key: "CLOUD_PRODUCTIVITY__DROPBOX_BOX_GOOGLE_DRIVE_EXTRA_STORAGE",
        categoryKey: "CLOUD_PRODUCTIVITY",
        categoryLabel: "Cloud & Productivity Software",
        categoryOrder: 4,
        lineOrder: 2,
        title: "Dropbox / Box / Google Drive (extra storage)",
        completenessRule: null
      },
      {
        key: "CLOUD_PRODUCTIVITY__ADOBE_ACROBAT",
        categoryKey: "CLOUD_PRODUCTIVITY",
        categoryLabel: "Cloud & Productivity Software",
        categoryOrder: 4,
        lineOrder: 3,
        title: "Adobe Acrobat",
        completenessRule: null
      },
      {
        key: "CLOUD_PRODUCTIVITY__ADOBE_CREATIVE_CLOUD",
        categoryKey: "CLOUD_PRODUCTIVITY",
        categoryLabel: "Cloud & Productivity Software",
        categoryOrder: 4,
        lineOrder: 4,
        title: "Adobe Creative Cloud",
        completenessRule: null
      },
      {
        key: "CLOUD_PRODUCTIVITY__E_SIGNATURE_DOCUSIGN_ADOBE_SIGN",
        categoryKey: "CLOUD_PRODUCTIVITY",
        categoryLabel: "Cloud & Productivity Software",
        categoryOrder: 4,
        lineOrder: 5,
        title: "E-signature (DocuSign, Adobe Sign)",
        completenessRule: null
      },
      {
        key: "CLOUD_PRODUCTIVITY__CANVA_OR_DESIGN_TOOLS",
        categoryKey: "CLOUD_PRODUCTIVITY",
        categoryLabel: "Cloud & Productivity Software",
        categoryOrder: 4,
        lineOrder: 6,
        title: "Canva or design tools",
        completenessRule: null
      },
      {
        key: "CLOUD_PRODUCTIVITY__PROJECT_TASK_MANAGEMENT_ASANA_MONDAY_TRELLO",
        categoryKey: "CLOUD_PRODUCTIVITY",
        categoryLabel: "Cloud & Productivity Software",
        categoryOrder: 4,
        lineOrder: 7,
        title: "Project / task management (Asana, Monday, Trello)",
        completenessRule: null
      },
      {
        key: "CLOUD_PRODUCTIVITY__NOTE_KNOWLEDGE_TOOLS_EVERNOTE_NOTION",
        categoryKey: "CLOUD_PRODUCTIVITY",
        categoryLabel: "Cloud & Productivity Software",
        categoryOrder: 4,
        lineOrder: 8,
        title: "Note & knowledge tools (Evernote, Notion)",
        completenessRule: null
      },
      {
        key: "CLOUD_PRODUCTIVITY__AI_TOOLS_CHATGPT_COPILOT_OTHER",
        categoryKey: "CLOUD_PRODUCTIVITY",
        categoryLabel: "Cloud & Productivity Software",
        categoryOrder: 4,
        lineOrder: 9,
        title: "AI tools (ChatGPT, Copilot, other)",
        completenessRule: null
      }
    ]
  },
  {
    key: "CONSTRUCTION_FIELD",
    order: 5,
    label: "Construction & Field Software",
    items: [
      {
        key: "CONSTRUCTION_FIELD__PROCORE",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 1,
        title: "Procore",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__BUILDERTREND_COCONSTRUCT",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 2,
        title: "Buildertrend / CoConstruct",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__SAGE_100_300_CRE_FOUNDATION_VIEWPOINT",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 3,
        title: "Sage 100/300 CRE, Foundation, Viewpoint",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__QUANTUM_AIA_BILLING",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 4,
        title: "Quantum (AIA billing)",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__BLUEBEAM_REVU",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 5,
        title: "Bluebeam Revu",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__TAKEOFF_SOFTWARE_PLANSWIFT_ON_SCREEN_TAKEOFF",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 6,
        title: "Takeoff software (PlanSwift, On-Screen Takeoff)",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__AUTOCAD_REVIT_AUTODESK",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 7,
        title: "AutoCAD / Revit / Autodesk",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__COMPANYCAM",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 8,
        title: "CompanyCam",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__DAILY_REPORTING_RAKEN_FIELDWIRE",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 9,
        title: "Daily reporting (Raken, Fieldwire)",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__TIME_TRACKING_CLOCKSHARK_BUSYBUSY",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 10,
        title: "Time tracking (ClockShark, busybusy)",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__SAFETY_TOOLBOX_TALK_SOFTWARE",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 11,
        title: "Safety & toolbox talk software",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__EQUIPMENT_FLEET_GPS_TELEMATICS",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 12,
        title: "Equipment / fleet GPS & telematics",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__TOOL_TRACKING",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 13,
        title: "Tool tracking",
        completenessRule: null
      },
      {
        key: "CONSTRUCTION_FIELD__SUBMITTAL_RFI_PUNCH_LIST_TOOLS",
        categoryKey: "CONSTRUCTION_FIELD",
        categoryLabel: "Construction & Field Software",
        categoryOrder: 5,
        lineOrder: 14,
        title: "Submittal / RFI / punch list tools",
        completenessRule: null
      }
    ]
  },
  {
    key: "BID_PRECONSTRUCTION",
    order: 6,
    label: "Bid & Preconstruction",
    items: [
      {
        key: "BID_PRECONSTRUCTION__PLAN_HUB",
        categoryKey: "BID_PRECONSTRUCTION",
        categoryLabel: "Bid & Preconstruction",
        categoryOrder: 6,
        lineOrder: 1,
        title: "Plan Hub",
        completenessRule: null
      },
      {
        key: "BID_PRECONSTRUCTION__CONSTRUCTCONNECT",
        categoryKey: "BID_PRECONSTRUCTION",
        categoryLabel: "Bid & Preconstruction",
        categoryOrder: 6,
        lineOrder: 2,
        title: "ConstructConnect",
        completenessRule: null
      },
      {
        key: "BID_PRECONSTRUCTION__DODGE_DATA_ANALYTICS",
        categoryKey: "BID_PRECONSTRUCTION",
        categoryLabel: "Bid & Preconstruction",
        categoryOrder: 6,
        lineOrder: 3,
        title: "Dodge Data & Analytics",
        completenessRule: null
      },
      {
        key: "BID_PRECONSTRUCTION__BUILDINGCONNECTED_ISQFT",
        categoryKey: "BID_PRECONSTRUCTION",
        categoryLabel: "Bid & Preconstruction",
        categoryOrder: 6,
        lineOrder: 4,
        title: "BuildingConnected / iSqFt",
        completenessRule: null
      },
      {
        key: "BID_PRECONSTRUCTION__BID_EXPRESS_STATE_MUNICIPAL_BID_PORTALS",
        categoryKey: "BID_PRECONSTRUCTION",
        categoryLabel: "Bid & Preconstruction",
        categoryOrder: 6,
        lineOrder: 5,
        title: "Bid Express / state & municipal bid portals",
        completenessRule: null
      },
      {
        key: "BID_PRECONSTRUCTION__BLUEPRINT_PRINTING_REPROGRAPHICS",
        categoryKey: "BID_PRECONSTRUCTION",
        categoryLabel: "Bid & Preconstruction",
        categoryOrder: 6,
        lineOrder: 6,
        title: "Blueprint printing & reprographics",
        completenessRule: null
      },
      {
        key: "BID_PRECONSTRUCTION__PLAN_ROOM_SUBSCRIPTIONS",
        categoryKey: "BID_PRECONSTRUCTION",
        categoryLabel: "Bid & Preconstruction",
        categoryOrder: 6,
        lineOrder: 7,
        title: "Plan room subscriptions",
        completenessRule: null
      },
      {
        key: "BID_PRECONSTRUCTION__ESTIMATING_DATABASES_RSMEANS_ETC",
        categoryKey: "BID_PRECONSTRUCTION",
        categoryLabel: "Bid & Preconstruction",
        categoryOrder: 6,
        lineOrder: 8,
        title: "Estimating databases (RSMeans, etc.)",
        completenessRule: null
      }
    ]
  },
  {
    key: "ACCOUNTING_PAYROLL_BANKING",
    order: 7,
    label: "Accounting, Payroll & Banking",
    items: [
      {
        key: "ACCOUNTING_PAYROLL_BANKING__QUICKBOOKS_OR_OTHER_GL",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 1,
        title: "QuickBooks (or other GL)",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__PAYROLL_PROCESSOR_ADP_PAYCHEX_GUSTO",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 2,
        title: "Payroll processor (ADP, Paychex, Gusto)",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__CERTIFIED_PAYROLL_PREVAILING_WAGE_SERVICE",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 3,
        title: "Certified payroll / prevailing wage service",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__GMR_FRINGE_ADMINISTRATION",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 4,
        title: "GMR fringe administration",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__OUTSOURCED_BOOKKEEPING_CONTROLLER_FEES_ONLY",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 5,
        title: "Outsourced bookkeeping / controller (fees only)",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__CPA_TAX_PREP_ANNUAL_REVIEW",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 6,
        title: "CPA \u2014 tax prep & annual review",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__CPA_AUDIT_OR_REVIEW_ENGAGEMENT",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 7,
        title: "CPA \u2014 audit or review engagement",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__BILL_PAY_BILL_COM",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 8,
        title: "Bill pay (Bill.com)",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__EXPENSE_RECEIPT_EXPENSIFY_RAMP",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 9,
        title: "Expense & receipt (Expensify, Ramp)",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__CORPORATE_CARD_ANNUAL_FEES",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 10,
        title: "Corporate card annual fees",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__BANK_ACCOUNT_ANALYSIS_FEES",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 11,
        title: "Bank account & analysis fees",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__CREDIT_CARD_PROCESSING_STATE_RATE_FEES",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 12,
        title: "Credit card processing (state % rate + fees)",
        completenessRule: "CARD_ACH_PROCESSING"
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__ACH_WIRE_FEES",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 13,
        title: "ACH / wire fees",
        completenessRule: "CARD_ACH_PROCESSING"
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__LOCKBOX_OR_REMOTE_DEPOSIT",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 14,
        title: "Lockbox or remote deposit",
        completenessRule: null
      },
      {
        key: "ACCOUNTING_PAYROLL_BANKING__LINE_OF_CREDIT_FEES_INTEREST",
        categoryKey: "ACCOUNTING_PAYROLL_BANKING",
        categoryLabel: "Accounting, Payroll & Banking",
        categoryOrder: 7,
        lineOrder: 15,
        title: "Line of credit fees & interest",
        completenessRule: null
      }
    ]
  },
  {
    key: "INSURANCE_BONDING_COMPLIANCE",
    order: 8,
    label: "Insurance, Bonding & Compliance",
    items: [
      {
        key: "INSURANCE_BONDING_COMPLIANCE__GENERAL_LIABILITY",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 1,
        title: "General liability",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__WORKERS_COMPENSATION",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 2,
        title: "Workers compensation",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__COMMERCIAL_AUTO_FLEET",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 3,
        title: "Commercial auto / fleet",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__UMBRELLA_EXCESS",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 4,
        title: "Umbrella / excess",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__CYBER_LIABILITY",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 5,
        title: "Cyber liability",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__PROFESSIONAL_LIABILITY_E_O",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 6,
        title: "Professional liability / E&O",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__BUILDERS_RISK",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 7,
        title: "Builders risk",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__SURETY_BOND_PREMIUMS",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 8,
        title: "Surety bond premiums",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__BOND_BROKER_FEES",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 9,
        title: "Bond broker fees",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__COI_TRACKING_SERVICE",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 10,
        title: "COI tracking service",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__CONTRACTOR_PREQUALIFICATION_SERVICES",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 11,
        title: "Contractor prequalification services",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__SAFETY_OSHA_TRAINING",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 12,
        title: "Safety / OSHA training",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__DRUG_ALCOHOL_TESTING_PROGRAM",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 13,
        title: "Drug & alcohol testing program",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__LICENCES_REGISTRATIONS_PERMITS",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 14,
        title: "Licences, registrations & permits",
        completenessRule: null
      },
      {
        key: "INSURANCE_BONDING_COMPLIANCE__TRADE_ASSOCIATION_UNION_DUES",
        categoryKey: "INSURANCE_BONDING_COMPLIANCE",
        categoryLabel: "Insurance, Bonding & Compliance",
        categoryOrder: 8,
        lineOrder: 15,
        title: "Trade association & union dues",
        completenessRule: null
      }
    ]
  },
  {
    key: "LEGAL_PROFESSIONAL",
    order: 9,
    label: "Legal & Professional",
    items: [
      {
        key: "LEGAL_PROFESSIONAL__OUTSIDE_COUNSEL_RETAINER",
        categoryKey: "LEGAL_PROFESSIONAL",
        categoryLabel: "Legal & Professional",
        categoryOrder: 9,
        lineOrder: 1,
        title: "Outside counsel retainer",
        completenessRule: null
      },
      {
        key: "LEGAL_PROFESSIONAL__CONTRACT_REVIEW_LAST_12_MONTHS_TOTAL",
        categoryKey: "LEGAL_PROFESSIONAL",
        categoryLabel: "Legal & Professional",
        categoryOrder: 9,
        lineOrder: 2,
        title: "Contract review (last 12 months total)",
        completenessRule: null
      },
      {
        key: "LEGAL_PROFESSIONAL__LIEN_FILING_COLLECTIONS_SERVICE",
        categoryKey: "LEGAL_PROFESSIONAL",
        categoryLabel: "Legal & Professional",
        categoryOrder: 9,
        lineOrder: 3,
        title: "Lien filing / collections service",
        completenessRule: null
      },
      {
        key: "LEGAL_PROFESSIONAL__REGISTERED_AGENT",
        categoryKey: "LEGAL_PROFESSIONAL",
        categoryLabel: "Legal & Professional",
        categoryOrder: 9,
        lineOrder: 4,
        title: "Registered agent",
        completenessRule: null
      },
      {
        key: "LEGAL_PROFESSIONAL__HR_SERVICES_OR_PEO",
        categoryKey: "LEGAL_PROFESSIONAL",
        categoryLabel: "Legal & Professional",
        categoryOrder: 9,
        lineOrder: 5,
        title: "HR services or PEO",
        completenessRule: null
      },
      {
        key: "LEGAL_PROFESSIONAL__BUSINESS_CONSULTANTS_OR_COACHES",
        categoryKey: "LEGAL_PROFESSIONAL",
        categoryLabel: "Legal & Professional",
        categoryOrder: 9,
        lineOrder: 6,
        title: "Business consultants or coaches",
        completenessRule: null
      }
    ]
  },
  {
    key: "SALES_MARKETING_WEB",
    order: 10,
    label: "Sales, Marketing & Web",
    items: [
      {
        key: "SALES_MARKETING_WEB__WEBSITE_HOSTING",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 1,
        title: "Website hosting",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__DOMAIN_REGISTRATION_SSL",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 2,
        title: "Domain registration & SSL",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__WEBSITE_MAINTENANCE_OR_AGENCY",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 3,
        title: "Website maintenance or agency",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__SEO_SERVICES",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 4,
        title: "SEO services",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__GOOGLE_ADS_PAID_SEARCH",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 5,
        title: "Google Ads / paid search",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__SOCIAL_MEDIA_MANAGEMENT",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 6,
        title: "Social media management",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__PHOTOGRAPHY_VIDEO",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 7,
        title: "Photography & video",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__PRINT_SIGNAGE_BRANDED_APPAREL",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 8,
        title: "Print, signage & branded apparel",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__TRADE_SHOWS_SPONSORSHIPS",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 9,
        title: "Trade shows & sponsorships",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__CRM_HUBSPOT_SALESFORCE_PIPEDRIVE",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 10,
        title: "CRM (HubSpot, Salesforce, Pipedrive)",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__EMAIL_MARKETING_MAILCHIMP_CONSTANT_CONTACT",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 11,
        title: "Email marketing (Mailchimp, Constant Contact)",
        completenessRule: null
      },
      {
        key: "SALES_MARKETING_WEB__LEAD_GENERATION_ANGI_HOUZZ_THUMBTACK_BUILDZOOM",
        categoryKey: "SALES_MARKETING_WEB",
        categoryLabel: "Sales, Marketing & Web",
        categoryOrder: 10,
        lineOrder: 12,
        title: "Lead generation (Angi, Houzz, Thumbtack, BuildZoom)",
        completenessRule: null
      }
    ]
  },
  {
    key: "DOCUMENTS_RECORDS",
    order: 11,
    label: "Documents & Records",
    items: [
      {
        key: "DOCUMENTS_RECORDS__DOCUMENT_SCANNING_SERVICE",
        categoryKey: "DOCUMENTS_RECORDS",
        categoryLabel: "Documents & Records",
        categoryOrder: 11,
        lineOrder: 1,
        title: "Document scanning service",
        completenessRule: null
      },
      {
        key: "DOCUMENTS_RECORDS__OFFSITE_RECORDS_STORAGE_IRON_MOUNTAIN",
        categoryKey: "DOCUMENTS_RECORDS",
        categoryLabel: "Documents & Records",
        categoryOrder: 11,
        lineOrder: 2,
        title: "Offsite records storage (Iron Mountain)",
        completenessRule: null
      },
      {
        key: "DOCUMENTS_RECORDS__SHREDDING_SERVICE",
        categoryKey: "DOCUMENTS_RECORDS",
        categoryLabel: "Documents & Records",
        categoryOrder: 11,
        lineOrder: 3,
        title: "Shredding service",
        completenessRule: null
      },
      {
        key: "DOCUMENTS_RECORDS__DOCUMENT_MANAGEMENT_SOFTWARE",
        categoryKey: "DOCUMENTS_RECORDS",
        categoryLabel: "Documents & Records",
        categoryOrder: 11,
        lineOrder: 4,
        title: "Document management software",
        completenessRule: null
      },
      {
        key: "DOCUMENTS_RECORDS__ARCHIVE_SUPPLIES_BOXES",
        categoryKey: "DOCUMENTS_RECORDS",
        categoryLabel: "Documents & Records",
        categoryOrder: 11,
        lineOrder: 5,
        title: "Archive supplies & boxes",
        completenessRule: null
      }
    ]
  },
  {
    key: "FLEET_EQUIPMENT_FIELD",
    order: 12,
    label: "Fleet, Equipment & Field Ops",
    items: [
      {
        key: "FLEET_EQUIPMENT_FIELD__VEHICLE_LEASES_OR_LOAN_PAYMENTS",
        categoryKey: "FLEET_EQUIPMENT_FIELD",
        categoryLabel: "Fleet, Equipment & Field Ops",
        categoryOrder: 12,
        lineOrder: 1,
        title: "Vehicle leases or loan payments",
        completenessRule: null
      },
      {
        key: "FLEET_EQUIPMENT_FIELD__FUEL_CARDS_FUEL_SPEND",
        categoryKey: "FLEET_EQUIPMENT_FIELD",
        categoryLabel: "Fleet, Equipment & Field Ops",
        categoryOrder: 12,
        lineOrder: 2,
        title: "Fuel cards & fuel spend",
        completenessRule: null
      },
      {
        key: "FLEET_EQUIPMENT_FIELD__VEHICLE_MAINTENANCE_REPAIR",
        categoryKey: "FLEET_EQUIPMENT_FIELD",
        categoryLabel: "Fleet, Equipment & Field Ops",
        categoryOrder: 12,
        lineOrder: 3,
        title: "Vehicle maintenance & repair",
        completenessRule: null
      },
      {
        key: "FLEET_EQUIPMENT_FIELD__EQUIPMENT_RENTAL_AGREEMENTS",
        categoryKey: "FLEET_EQUIPMENT_FIELD",
        categoryLabel: "Fleet, Equipment & Field Ops",
        categoryOrder: 12,
        lineOrder: 4,
        title: "Equipment rental agreements",
        completenessRule: null
      },
      {
        key: "FLEET_EQUIPMENT_FIELD__TOOL_EQUIPMENT_SUBSCRIPTIONS",
        categoryKey: "FLEET_EQUIPMENT_FIELD",
        categoryLabel: "Fleet, Equipment & Field Ops",
        categoryOrder: 12,
        lineOrder: 5,
        title: "Tool & equipment subscriptions",
        completenessRule: null
      },
      {
        key: "FLEET_EQUIPMENT_FIELD__UNIFORM_LAUNDRY_SERVICE",
        categoryKey: "FLEET_EQUIPMENT_FIELD",
        categoryLabel: "Fleet, Equipment & Field Ops",
        categoryOrder: 12,
        lineOrder: 6,
        title: "Uniform / laundry service",
        completenessRule: null
      },
      {
        key: "FLEET_EQUIPMENT_FIELD__JOBSITE_TRAILER_OR_CONTAINER_RENTAL",
        categoryKey: "FLEET_EQUIPMENT_FIELD",
        categoryLabel: "Fleet, Equipment & Field Ops",
        categoryOrder: 12,
        lineOrder: 7,
        title: "Jobsite trailer or container rental",
        completenessRule: null
      },
      {
        key: "FLEET_EQUIPMENT_FIELD__PORTABLE_TOILETS_SITE_SERVICES",
        categoryKey: "FLEET_EQUIPMENT_FIELD",
        categoryLabel: "Fleet, Equipment & Field Ops",
        categoryOrder: 12,
        lineOrder: 8,
        title: "Portable toilets & site services",
        completenessRule: null
      },
      {
        key: "FLEET_EQUIPMENT_FIELD__DUMPSTER_DISPOSAL",
        categoryKey: "FLEET_EQUIPMENT_FIELD",
        categoryLabel: "Fleet, Equipment & Field Ops",
        categoryOrder: 12,
        lineOrder: 9,
        title: "Dumpster & disposal",
        completenessRule: null
      }
    ]
  },
  {
    key: "HR_WORKFORCE",
    order: 13,
    label: "HR & Workforce",
    items: [
      {
        key: "HR_WORKFORCE__JOB_BOARDS_INDEED_ZIPRECRUITER",
        categoryKey: "HR_WORKFORCE",
        categoryLabel: "HR & Workforce",
        categoryOrder: 13,
        lineOrder: 1,
        title: "Job boards (Indeed, ZipRecruiter)",
        completenessRule: null
      },
      {
        key: "HR_WORKFORCE__APPLICANT_TRACKING_SYSTEM",
        categoryKey: "HR_WORKFORCE",
        categoryLabel: "HR & Workforce",
        categoryOrder: 13,
        lineOrder: 2,
        title: "Applicant tracking system",
        completenessRule: null
      },
      {
        key: "HR_WORKFORCE__BACKGROUND_CHECKS",
        categoryKey: "HR_WORKFORCE",
        categoryLabel: "HR & Workforce",
        categoryOrder: 13,
        lineOrder: 3,
        title: "Background checks",
        completenessRule: null
      },
      {
        key: "HR_WORKFORCE__HRIS_BENEFITS_ADMINISTRATION",
        categoryKey: "HR_WORKFORCE",
        categoryLabel: "HR & Workforce",
        categoryOrder: 13,
        lineOrder: 4,
        title: "HRIS / benefits administration",
        completenessRule: null
      },
      {
        key: "HR_WORKFORCE__HEALTH_DENTAL_VISION_BROKERAGE_FEES",
        categoryKey: "HR_WORKFORCE",
        categoryLabel: "HR & Workforce",
        categoryOrder: 13,
        lineOrder: 5,
        title: "Health, dental & vision brokerage fees",
        completenessRule: null
      },
      {
        key: "HR_WORKFORCE__401_K_ADMINISTRATION_FEES",
        categoryKey: "HR_WORKFORCE",
        categoryLabel: "HR & Workforce",
        categoryOrder: 13,
        lineOrder: 6,
        title: "401(k) administration fees",
        completenessRule: null
      },
      {
        key: "HR_WORKFORCE__TRAINING_CERTIFICATION_PLATFORMS",
        categoryKey: "HR_WORKFORCE",
        categoryLabel: "HR & Workforce",
        categoryOrder: 13,
        lineOrder: 7,
        title: "Training & certification platforms",
        completenessRule: null
      },
      {
        key: "HR_WORKFORCE__EMPLOYEE_HANDBOOK_POLICY_SERVICE",
        categoryKey: "HR_WORKFORCE",
        categoryLabel: "HR & Workforce",
        categoryOrder: 13,
        lineOrder: 8,
        title: "Employee handbook / policy service",
        completenessRule: null
      }
    ]
  },
  {
    key: "OTHER_UNASSIGNED",
    order: 14,
    label: "Other & Unassigned",
    items: [
      {
        key: "OTHER_UNASSIGNED__SUBSCRIPTION_ON_A_PERSONAL_CARD",
        categoryKey: "OTHER_UNASSIGNED",
        categoryLabel: "Other & Unassigned",
        categoryOrder: 14,
        lineOrder: 1,
        title: "Subscription on a personal card",
        completenessRule: "PERSONAL_CARD_SUBSCRIPTIONS"
      },
      {
        key: "OTHER_UNASSIGNED__ANNUAL_MEMBERSHIP_NOBODY_OWNS",
        categoryKey: "OTHER_UNASSIGNED",
        categoryLabel: "Other & Unassigned",
        categoryOrder: 14,
        lineOrder: 2,
        title: "Annual membership nobody owns",
        completenessRule: null
      },
      {
        key: "OTHER_UNASSIGNED__AUTO_RENEWAL_FOUND_ON_STATEMENT_REVIEW",
        categoryKey: "OTHER_UNASSIGNED",
        categoryLabel: "Other & Unassigned",
        categoryOrder: 14,
        lineOrder: 3,
        title: "Auto-renewal found on statement review",
        completenessRule: null
      },
      {
        key: "OTHER_UNASSIGNED__OTHER",
        categoryKey: "OTHER_UNASSIGNED",
        categoryLabel: "Other & Unassigned",
        categoryOrder: 14,
        lineOrder: 4,
        title: "Other",
        completenessRule: null
      }
    ]
  }
];
var CLC_FLAT_LINE_ITEMS = CLC_SPEND_CATALOG.flatMap((category) => category.items);
var CLC_ONBOARDING_STAGES = [
  { key: "STAGE_1_COMPANY", order: 1, label: "Company" },
  { key: "STAGE_2_PEOPLE", order: 2, label: "People" },
  { key: "STAGE_3_SYSTEMS", order: 3, label: "Systems" },
  { key: "STAGE_4_SPEND", order: 4, label: "Spend" },
  { key: "STAGE_5_DOCUMENTS", order: 5, label: "Documents" },
  { key: "STAGE_6_INTEGRATIONS", order: 6, label: "Integrations" },
  { key: "STAGE_7_WORKFLOWS", order: 7, label: "Workflows" },
  { key: "STAGE_8_VALIDATE", order: 8, label: "Validate" },
  { key: "STAGE_9_LAUNCH", order: 9, label: "Launch" }
];
var CLC_WORKSTREAMS = [
  { key: "COMPANY_ORG", order: 1, label: "Company & Organization" },
  { key: "VENDORS_TECH", order: 2, label: "Vendors & Technology" },
  { key: "FINANCIAL_SPEND", order: 3, label: "Financial & Spend" },
  { key: "DOCUMENTS_CONTRACTS", order: 4, label: "Documents & Contracts" },
  { key: "SYSTEMS_INTEGRATIONS", order: 5, label: "Systems & Integrations" },
  { key: "IMPLEMENTATION_DECISIONS", order: 6, label: "Implementation Decisions" },
  { key: "DATA_MIGRATION", order: 7, label: "Data Migration" },
  { key: "VALIDATION_UAT", order: 8, label: "Validation / UAT" }
];
var CLC_VAULT_CATEGORIES = [
  "Corporate",
  "Finance",
  "Vendor Contracts",
  "Insurance & Bonding",
  "Systems & Integrations",
  "Implementation",
  "Legal",
  "HR",
  "Fleet & Equipment",
  "Projects",
  "Other"
];

// src/dashboard-attention.ts
var DASHBOARD_ATTENTION_OUTCOMES = [
  "vendor_catalog_confirmed",
  "material_punch_list_approved",
  "takeoff_run_refused",
  "company_cost_approved",
  "bid_assembly_approved",
  "finance_cash_approved",
  "payroll_workweek_reviewed",
  "payroll_reconciliation_reviewed",
  "wage_authority_published",
  "certified_evidence_signed",
  "insurance_evidence_accepted",
  "compliance_assessment_recorded"
];
var DASHBOARD_ATTENTION_TONES = ["positive", "warning", "neutral"];
var DASHBOARD_ATTENTION_DEFINITIONS = {
  vendor_catalog_confirmed: {
    eventName: "procurement.vendors.catalog_confirmed",
    topic: "procurement.vendors",
    permission: "procurement:vendors:read",
    entityType: "CatalogIngestRun",
    text: "Vendor catalog confirmed",
    tone: "positive",
    versionKind: "timestamp"
  },
  material_punch_list_approved: {
    eventName: "takeoff.punch_lists.approved",
    topic: "takeoff.punch_lists",
    permission: "takeoff:punch_lists:read",
    entityType: "MaterialPunchList",
    text: "Material punch list approved",
    tone: "positive",
    versionKind: "positive_integer"
  },
  takeoff_run_refused: {
    eventName: "takeoff.runs.created",
    topic: "takeoff.runs",
    permission: "takeoff:runs:read",
    entityType: "TakeoffRun",
    text: "Drawing measurement needs review",
    tone: "warning",
    versionKind: "positive_integer"
  },
  company_cost_approved: {
    eventName: "estimating.company_costs.approved",
    topic: "estimating.company_costs",
    permission: "estimating:company_costs:read",
    entityType: "CompanyCostRevision",
    text: "Company cost approved",
    tone: "positive",
    versionKind: "positive_integer"
  },
  bid_assembly_approved: {
    eventName: "bidding.assemblies.approved",
    topic: "bidding.assemblies",
    permission: "bidding:assemblies:read",
    entityType: "BidAssembly",
    text: "Internal bid approved",
    tone: "positive",
    versionKind: "positive_integer"
  },
  finance_cash_approved: {
    eventName: "finance.cash_flow_forecasts.approved",
    topic: "finance.cash_flow_forecasts",
    permission: "finance:cash_flow_forecasts:read",
    entityType: "CashScenario",
    text: "Cash forecast approved",
    tone: "positive",
    versionKind: "positive_integer"
  },
  payroll_workweek_reviewed: {
    eventName: "payroll.exports.workweek_reviewed",
    topic: "payroll.exports",
    permission: "payroll:exports:read",
    entityType: "PayrollWorkweekAttestation",
    text: "Workweek scope reviewed",
    tone: "positive",
    versionKind: "receipt_identity"
  },
  payroll_reconciliation_reviewed: {
    eventName: "payroll.results.reconciliation_reviewed",
    topic: "payroll.results",
    permission: "payroll:results:read",
    entityType: "PayrollResultReview",
    text: "Payroll reconciliation reviewed",
    tone: "positive",
    versionKind: "positive_integer"
  },
  wage_authority_published: {
    eventName: "payroll.wage_schedules.authority_published",
    topic: "payroll.wage_schedules",
    permission: "payroll:wage_schedules:read",
    entityType: "WageAuthorityRevision",
    text: "Wage authority published",
    tone: "positive",
    versionKind: "positive_integer"
  },
  certified_evidence_signed: {
    eventName: "payroll.certified_payroll.evidence_signed",
    topic: "payroll.certified_payroll",
    permission: "payroll:certified_payroll:read",
    entityType: "CertifiedPayrollEvidenceAssessment",
    text: "Certified evidence signed locally",
    tone: "positive",
    versionKind: "positive_integer"
  },
  insurance_evidence_accepted: {
    eventName: "insurance.policies.evidence_accepted",
    topic: "insurance.policies",
    permission: "insurance:policies:read",
    entityType: "InsuranceEvidenceReview",
    text: "Insurance evidence review recorded",
    tone: "positive",
    versionKind: "receipt_identity"
  },
  compliance_assessment_recorded: {
    eventName: "compliance.insurance_certificates.assessed",
    topic: "compliance.insurance_certificates",
    permission: "compliance:insurance_certificates:read",
    entityType: "VendorProjectComplianceCase",
    text: "Compliance assessment recorded",
    tone: "neutral",
    versionKind: "receipt_identity"
  }
};
var DASHBOARD_ATTENTION_CATALOG = Object.freeze(
  Object.fromEntries(
    Object.entries(DASHBOARD_ATTENTION_DEFINITIONS).map(
      ([key, { versionKind: _kind, ...value }]) => [key, Object.freeze(value)]
    )
  )
);
var DASHBOARD_ATTENTION_VERSION_KINDS = Object.freeze(
  Object.fromEntries(
    Object.entries(DASHBOARD_ATTENTION_DEFINITIONS).map(([key, value]) => [key, value.versionKind])
  )
);

// src/portal-onboarding-declarations.ts
var ONBOARDING_SIGNATURE_DECLARATIONS = Object.freeze([
  "I am authorized to complete this declaration on behalf of my company.",
  "I consent to use my typed name as my electronic signature for the exact declaration shown.",
  "I understand that company onboarding does not authorize project work or confirm payment readiness."
]);
var ONBOARDING_ACKNOWLEDGMENT_DECLARATIONS = Object.freeze([
  "I acknowledge that I have read this exact published material."
]);

// src/portal-guide.ts
var PORTAL_GUIDE_VERSION = 2;
var PORTAL_GUIDE_UPDATED = "2026-10-15";
var PORTAL_GUIDE_FACTS = [
  {
    key: "onboarding",
    title: "Complete company onboarding",
    content: "Open Company onboarding to complete eight saved steps: Company and contacts, Tax information, Insurance and licenses, Agreements, Payment setup, Safety and qualifications, Working with Meyer, and Review and submit. Use the exact packet assigned in your portal. A company waiting for a published packet must contact Meyer; this guide does not publish a packet or approve a company. Save your work and return to the same portal. Review the outstanding actions and submit the packet for the named reviewers."
  },
  {
    key: "documents",
    title: "Use the correct document task",
    content: "Complete or upload tax paperwork only through the restricted Tax information task. Upload a current certificate of insurance and the supporting endorsements requested for your work in Insurance and licenses. An insurance certificate summarizes a policy; the named reviewer accepts the applicable evidence. Provide licenses when assigned as applicable. Read and sign the exact inline declaration in Agreements; an actual subcontract or work order remains a separate document. Keep accepted documents current in Compliance and renewals. Documents shows only files shared with your company and project access."
  },
  {
    key: "approvals",
    title: "Know which approval you need",
    content: "Company approval, Accounting payment readiness and project start authorization are separate decisions. Submitted evidence can still be awaiting review. Correct a returned item using the review reason. An approved company profile or visible work record does not authorize a project start. Wait for the project team to give explicit authorization for that job and satisfy its actual agreement, insurance and site requirements."
  },
  {
    key: "work",
    title: "Understand your assigned work",
    content: "Use Projects for the jobs shared with your account, Your work for your company\u2019s issued contracts and purchase orders, and Documents for the plans and files explicitly shared with you. Review the actual scope, agreement, schedule and current document revision. Ask the project team for written approval before changed or extra work. A job-aware AI answer explains available sources; it cannot change the scope, authorize a start, approve a change or override an executed agreement."
  },
  {
    key: "existing-ap",
    title: "Set up payment through existing accounts payable",
    content: "Meyer\u2019s existing accounts payable process is the default payment route. Accounting confirms your approved vendor/payee record, tax evidence, remittance contact and secure payment-method enrollment. Follow the terms in your actual agreement. Stripe enrollment is not required for this route. Never put bank or routing numbers in portal questions, Messages, ordinary uploads or the company profile. Use only the secure enrollment channel supplied by established Meyer Accounting contacts and verify payment-instruction changes directly with them."
  },
  {
    key: "invoice",
    title: "Submit an invoice and track its review",
    content: "Open Money or Invoices and payments, choose Submit invoice, select the assigned project and purchase order when applicable, and provide your invoice number, dates, amount and original invoice file with requested supporting evidence. Use the actual agreement for terms, retainage and waiver requirements. Track the invoice in the portal and correct returned items as instructed. Submission is not approval. Accounting approves and issues payment through the existing AP process. A recorded payment or provider status is not independent proof of money reaching your bank; use remittance details and your bank record, and ask Accounting to reconcile missing or unclear payment information."
  },
  {
    key: "payment-direction",
    title: "Distinguish receiving payment from paying a client invoice",
    content: "A subcontractor submits an invoice to Meyer and receives payment through Meyer\u2019s approved AP process. A client invoice is money a customer owes Meyer and appears only in the client payment view. Online customer checkout is available only when Meyer has enabled and configured the provider; otherwise follow the payment instructions from Accounting. Customer checkout does not enroll a subcontractor for payment. AI cannot release payments, change bank instructions or guarantee a payment date."
  },
  {
    key: "assistant",
    title: "Ask a question and follow the answer",
    content: "Open Ask Meyer AI, choose Company onboarding or one of your assigned projects, and ask a specific question. AI selects source excerpts from the product guide and available authorized company, packet, issued-work and readable shared-document sources. The portal displays verified literal sentences with source titles, revisions and pages when available; it does not publish model-written interpretations. Read the surrounding source context and request Meyer review for interpretation, confirmation or approval. The assistant cannot read unshared files, other companies\u2019 information or restricted tax and bank files. Image-only scans and unsupported files may require a searchable copy or Meyer review. If the provider is unavailable or usable excerpts are missing, the question is saved for Meyer review. Use Request Meyer review and follow Saved questions for its status and reply. For immediate site hazards or emergencies, contact the project or safety team directly rather than waiting for the assistant."
  }
];

// src/crm-display-name.ts
var CRM_JOB_NAME_PATTERN = "^([0-9]{2}-[0-9]{3,6})[[:space:]]+(.+)$";
function relationshipDisplayName(originalName) {
  const match = /^([0-9]{2}-[0-9]{3,6})\s+(.+)$/.exec(originalName.trim());
  const remainder = match?.[2]?.trim();
  return {
    cleanName: remainder || originalName,
    originalName,
    sourceCode: remainder ? match[1] : null
  };
}

// src/job-binder.ts
var JOB_CHAPTERS = [
  { id: "bids", label: "Bids & estimates" },
  { id: "contracts", label: "Contracts & insurance" },
  { id: "drawings", label: "Drawings & specifications" },
  { id: "correspondence", label: "Emails & correspondence" },
  { id: "rfis", label: "RFIs & submittals" },
  { id: "changes", label: "Change orders" },
  { id: "financial", label: "Procurement & billing" },
  { id: "field", label: "Field, safety & quality" },
  { id: "permits", label: "Permits & inspections" },
  { id: "closeout", label: "Closeout & warranties" },
  { id: "other", label: "Other records" }
];

export { AgentStatus, AlertStatus, ApiKeyStatus, CLC_FLAT_LINE_ITEMS, CLC_ONBOARDING_STAGES, CLC_SPEND_CATALOG, CLC_VAULT_CATEGORIES, CLC_WORKSTREAMS, CRM_JOB_NAME_PATTERN, DASHBOARD_ATTENTION_CATALOG, DASHBOARD_ATTENTION_DEFINITIONS, DASHBOARD_ATTENTION_OUTCOMES, DASHBOARD_ATTENTION_TONES, DASHBOARD_ATTENTION_VERSION_KINDS, IntegrationStatus, JOB_CHAPTERS, NotificationChannel, NotificationType, ONBOARDING_ACKNOWLEDGMENT_DECLARATIONS, ONBOARDING_SIGNATURE_DECLARATIONS, PORTAL_GUIDE_FACTS, PORTAL_GUIDE_UPDATED, PORTAL_GUIDE_VERSION, ProjectPhase, ProjectStatus, RecommendationStatus, RecordStatus, RiskLevel, WebhookStatus, relationshipDisplayName };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map